import React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import { AUDIT_ACTION_LABELS } from './AuditActionChip';

const selectSx = {
  height: '40px',
  borderRadius: '8px',
  fontSize: '0.875rem',
  minWidth: 180,
  backgroundColor: '#fff',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E0E0E0' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#BDBDBD' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: 'primary.main' },
};

const textSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
    backgroundColor: '#fff',
    height: '40px',
    '& fieldset': { borderColor: '#E0E0E0' },
    '&:hover fieldset': { borderColor: '#BDBDBD' },
    '&.Mui-focused fieldset': { borderColor: 'primary.main' },
  },
  '& input': { fontSize: '0.875rem' },
};

/**
 * AuditFilters - Barra de filtros da tela de Auditoria (Admin Geral)
 * @param {Object} props
 * @param {Array<string>} props.actions - ações existentes (SELECT DISTINCT action)
 * @param {string} props.action
 * @param {Function} props.onActionChange
 * @param {string} props.companyInput
 * @param {Function} props.onCompanyInputChange
 * @param {string} props.searchInput
 * @param {Function} props.onSearchInputChange
 * @param {string} props.dateFrom
 * @param {Function} props.onDateFromChange
 * @param {string} props.dateTo
 * @param {Function} props.onDateToChange
 */
function AuditFilters({
  actions = [],
  action,
  onActionChange,
  companyInput,
  onCompanyInputChange,
  searchInput,
  onSearchInputChange,
  dateFrom,
  onDateFromChange,
  dateTo,
  onDateToChange,
}) {
  return (
    <Box
      sx={{
        p: 2,
        display: 'flex',
        alignItems: 'center',
        gap: 1.5,
        flexWrap: 'wrap',
        borderBottom: '1px solid #E8ECF0',
        bgcolor: '#fff',
      }}
    >
      <TextField
        size="small"
        placeholder="Buscar em empresa, admin, IP ou detalhes"
        value={searchInput}
        onChange={(e) => onSearchInputChange(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: 'text.disabled', fontSize: 18 }} />
            </InputAdornment>
          ),
        }}
        sx={{ flex: 1, minWidth: 240, maxWidth: { sm: 340 }, ...textSx }}
      />

      <Select size="small" value={action || ''} onChange={(e) => onActionChange(e.target.value)} sx={selectSx}>
        <MenuItem value="">Todas as ações</MenuItem>
        {actions.map((a) => (
          <MenuItem key={a} value={a}>{AUDIT_ACTION_LABELS[a] || a}</MenuItem>
        ))}
      </Select>

      <TextField
        size="small"
        placeholder="Empresa (id)"
        value={companyInput}
        onChange={(e) => onCompanyInputChange(e.target.value.replace(/[^0-9]/g, ''))}
        sx={{ width: 120, ...textSx }}
      />

      <TextField
        size="small"
        type="date"
        label="De"
        InputLabelProps={{ shrink: true }}
        value={dateFrom}
        onChange={(e) => onDateFromChange(e.target.value)}
        sx={{ width: 160, ...textSx }}
      />

      <TextField
        size="small"
        type="date"
        label="Até"
        InputLabelProps={{ shrink: true }}
        value={dateTo}
        onChange={(e) => onDateToChange(e.target.value)}
        sx={{ width: 160, ...textSx }}
      />
    </Box>
  );
}

export default AuditFilters;
